// **** Generated File: Do NOT edit!  **********
// Generated from java class: com.abinitio.webcommons.abweb.dto.inputargs.DateFilterValue
// using template webcommons/abinitio/build/codegen/src/main/resources/tsTemplates/TSClass.vm

import { DateFilterOperation } from "abweb/dto/generated/inputargs/DateFilterOperation";
import { FilterValue } from "abweb/dto/inputargs/FilterValue";
import { RelativeDateSpecifier } from "abweb/dto/inputargs/RelativeDateSpecifier";
import { DeserializeContext } from "abweb/utils/json/DeserializeContext";
import { TSOGUtils } from "abweb/utils/json/TSOGUtils";
export class DateFilterValueBase extends FilterValue {
  /** Do NOT invoke directly, instead use strongly typed createDateFilterValueBase factory method */
  constructor() {
    super();
  }

  // @ts-ignore: noUnusedLocals
  getJavaClass() {
    return "cawadi.DateFilterValue";
  }
  initFromJson(json, deserializeContext) {
    this.initDateFilterValue(json.componentGuid != null ? json.componentGuid : null, json.firstDate != null ? new Date(json.firstDate) : null, json.isDateTime != null ? json.isDateTime : null, json.isOpNegated != null ? json.isOpNegated : null, TSOGUtils.decodeObject(json.latest, RelativeDateSpecifier, deserializeContext, DeserializeContext.createFieldReferenceContext(this, "latest")), json.op != null ? DateFilterOperation.fromJson(json.op) : null, json.secondDate != null ? new Date(json.secondDate) : null);
  }
  initDateFilterValue(componentGuid, firstDate, isDateTime, isOpNegated, latest, op, secondDate) {
    this.initFilterValue(componentGuid);
    this._firstDate = firstDate;
    this._isDateTime = isDateTime;
    this._isOpNegated = isOpNegated;
    this._latest = latest;
    this._op = op;
    this._secondDate = secondDate;
  }
  toTSOG(result, serializeContext) {
    const retVal = super.toTSOG(result, serializeContext);
    if (this._firstDate != null) {
      retVal["firstDate"] = this._firstDate;
    }
    retVal["isDateTime"] = this._isDateTime;
    retVal["isOpNegated"] = this._isOpNegated;
    if (this._latest != null) {
      retVal["latest"] = TSOGUtils.toTSOGNativeObject(this._latest, serializeContext);
    }
    retVal["op"] = this._op;
    if (this._secondDate != null) {
      retVal["secondDate"] = this._secondDate;
    }
    return retVal;
  }
  get firstDate() {
    return this._firstDate;
  }
  set firstDate(value) {
    this._firstDate = value;
  }
  get isDateTime() {
    return this._isDateTime;
  }
  set isDateTime(value) {
    this._isDateTime = value;
  }
  get isOpNegated() {
    return this._isOpNegated;
  }
  set isOpNegated(value) {
    this._isOpNegated = value;
  }
  get latest() {
    return this._latest;
  }
  set latest(value) {
    this._latest = value;
  }
  get op() {
    return this._op;
  }
  set op(value) {
    this._op = value;
  }
  get secondDate() {
    return this._secondDate;
  }
  set secondDate(value) {
    this._secondDate = value;
  }
}
//# sourceMappingURL=DateFilterValueBase.js.map
